<template lang="html">
    <div class="container">
        <div class="loader" v-show="loading">
            <div class="trinity-rings-spinner">
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
            </div>
            <div class="loader-text">Un instant...</div>
        </div>
    <div v-if="!camIsHidden" class="row">
        <div class="row">
            <div class="col s12 m10 center">
                <br>
                <div class="card horizontal">
                    <div class="card-stacked">
                        <div class="card-content">

                            <h5 class="center blue-text">Partagez une photo de l'élément à améliorer</h5>
                            <br>
                            <p class="grey-text">A l'aide de votre appareil ou en téléchargeant un fichier depuis votre galerie</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col s12 m10 center">
                <label for="files" class="btn-large waves-effect waves-light light-blue">DEMARRER<i class="material-icons">arrow_next</i></label>
                <input id="files" type="file" @change="showFile" accept="image/*" style="visibility:hidden;" >
            </div>
        </div>

    </div>
    <div class="row">
        <div id="colors" class="hide">
            <button id="orange" class="btn-floating waves-effect waves-light orange"></button>
            <button id="yellow" class="btn-floating waves-effect waves-light yellow"></button>
            <button id="green" class="btn-floating waves-effect waves-light green"></button>
            <button id="black" class="btn-floating waves-effect waves-light black"></button>
            <button id="white" class="btn-floating waves-effect waves-light white"></button>
            <button id="blue" class="btn-floating waves-effect waves-light blue"></button>
            <button id="red" class="btn-floating waves-effect waves-light red"></button>
        </div>
        <div id="tools" class="hide">
            <button id="size1" class="btn-floating btn-small waves-effect waves-light light-blue"><i class="material-icons">edit</i></button>
            <button id="size2" class="btn-floating waves-effect waves-light light-blue"><i class="material-icons">edit</i></button>
            <button id="size3" class="btn-floating btn-large waves-effect waves-light light-blue"><i class="material-icons">edit</i></button>

            <!-- <a @click.prevent="rotateLeft()" class="btn btn-floating waves-effect waves-light light-blue"><i class="material-icons">undo</i></a>
            <a @click.prevent="rotateRight()" class="btn btn-floating waves-effect waves-light light-blue"><i class="material-icons">redo</i></a> -->

            <!-- <button class="btn-floating btn-small waves-effect waves-light light-blue"><i class="material-icons">brush</i></button>
            <button class="btn-floating waves-effect waves-light light-blue"><i class="material-icons">brush</i></button>
            <button class="btn-floating btn-large waves-effect waves-light light-blue"><i class="material-icons">brush</i></button> -->

        </div>
        <!-- redirects to home -->
        <router-link id="back" class="btn-large btn-floating waves-effect waves-light red" :to="{ name: 'Home'}"><i class="material-icons">arrow_back</i></router-link>

        <!-- show the tools -->
        <a v-if="camIsHidden && !editMode" id="edit" class="btn-large btn-floating waves-effect waves-light light-blue" @click="edit"><i class="material-icons">palette</i></a>
        <!-- to improvement creation -->
        <a v-if="camIsHidden" id="submit" @click='submit' class="valid btn-large btn-floating waves-effect waves-light green"><i class="material-icons">check</i></a>
        <!-- validate changes  -->
        <a v-if="camIsHidden" id="save" class="valid btn-large btn-floating waves-effect waves-light green hide"><i class="material-icons">save</i></a>
    </div>

    <div class="preview-row row">

        <img id="preview" v-if="!editMode">

        <canvas id='canvas' width="0" height="0" style="border:rgb(199, 235, 255) 1px solid;"></canvas>

        <!-- submit view -->
        <div id="form" class="hide">

            <form @submit.prevent="fireImprovement">
                <div class="row">
                    <div class="field col s12">
                        <label for="proposal">Proposition:</label>
                        <textarea class="materialize-textarea" name="proposal" rows="34" placeholder="Indiquez ici votre proposition" v-model="proposal"></textarea>
                    </div>
                    <div class="field col s12">
                        <label>Pouvez-vous indiquer un objet?</label>
                        <select class="browser-default" v-model="object">
                            <option value="" disabled selected>Objet</option>
                            <option value="Conception">Conception</option>
                            <option value="Logistique">Logistique</option>
                            <option value="Colisage">Colisage</option>
                            <option value="Production">Production</option>
                            <option value="Visserie">Visserie</option>
                            <option value="Fourniture">Fourniture</option>
                        </select>
                    </div>
                    <div class="field col s12">
                        <label>Quelle est la fréquence d'apparition du défaut?</label>
                        <select class="browser-default" v-model="frequency">
                            <option value="" disabled selected>Fréquence</option>
                            <option value="Unique">Unique</option>
                            <option value="Occasionnel">Occasionnel</option>
                            <option value="Régulier">Régulier</option>
                            <option value="Systématique">Systématique</option>
                        </select>
                    </div>
                </div>
                <div class="col s6">
                    <button class="btn waves-effect waves-light red" @click="$router.push({ name: 'Home' })">Annuler</button>
                </div>
                <div class="col s6">
                    <button class="btn waves-effect waves-light light-blue">Soumettre</button>
                </div>
            </form>
        </div>
    </div>
</div>


</template>

<script>
import db from '@/firebase/init'
import firebase from 'firebase/app'
import storage from 'firebase/storage'

import {fabric} from 'fabric'

export default {
    name: 'Media',
    data(){
        return{
            loading: false,
            proposal: null,
            frequency: null,
            object: null,
            camIsHidden: '',
            editMode:'',
            blob:'',
            blobURL: '',
            eBlob: null,
            eBlobURL: '',
            user: null,
            impRef: null,
            originalPic: null,
            originalPicURL: null,
            editedPic: null,
            editedPicURL: null
        }
    },
    methods: {
        showFile(){
            var file = document.querySelector('input[type=file]').files[0];
            var reader = new FileReader()

            reader.onload = function (event) {
                document.querySelector('#preview').src = reader.result
            }
            reader.readAsDataURL(file);
            const blob = new Blob([file],{type: 'image/png'})
//console.log(blob)
            this.blob = blob
//console.log(this.blob)
            //hide the camera Mode
            this.camIsHidden = true

            var blobURL = URL.createObjectURL(blob)
            this.blobURL = blobURL

            //validate pic and go on
            $('#preview').src = this.blobURL;
            //console.log(this.blobURL)

        },
        edit() {
            this.editMode = true

            let blob = this.blob
            var blobURL = URL.createObjectURL(blob)
            // console.log(blobURL)

            var canvas = new fabric.Canvas('canvas')
            var img = new Image()
            img.onload = function() {
                // this is syncronous
                var f_img = new fabric.Image(img)
                // canvas.setBackgroundImage(f_img);
                canvas.setBackgroundImage(f_img, canvas.renderAll.bind(canvas), {
                    scaleX: canvas.width / img.width,
                    scaleY: canvas.height / img.height
                })
                // canvas.renderAll();
            }
            img.src = blobURL

            //resize canvas to img size
            canvas.setHeight(jQuery('#preview').height())
            canvas.setWidth(jQuery('#preview').width())
            canvas.isDrawingMode = true
            canvas.freeDrawingBrush.width = 5
            canvas.freeDrawingBrush.color = '#2196f3'
            canvas.renderAll()
            //edition tools
            //show buttons

            $("#colors").removeClass("hide")
            $("#tools").removeClass("hide")
            $("#save").removeClass("hide")
            //colors
            $("#blue").click(function(){ canvas.freeDrawingBrush.color = '#2196f3' })
            $("#green").click(function(){ canvas.freeDrawingBrush.color = '#4CAF50' })
            $("#red").click(function(){ canvas.freeDrawingBrush.color = '#F44336' })
            $("#orange").click(function(){ canvas.freeDrawingBrush.color = '#ff9800' })
            $("#black").click(function(){ canvas.freeDrawingBrush.color = 'black' })
            $("#white").click(function(){ canvas.freeDrawingBrush.color = 'white' })
            $("#yellow").click(function(){ canvas.freeDrawingBrush.color = '#ffeb3b' })
            //sizes
            $("#size1").click(function(){ canvas.freeDrawingBrush.width = 3 })
            $("#size2").click(function(){ canvas.freeDrawingBrush.width = 5 })
            $("#size3").click(function(){ canvas.freeDrawingBrush.width = 10 })

            //validate editing and store to blob
            $("#save").click(() => {
                var editedImage = canvas.toDataURL('image/jpeg');
//console.log(editedImage)
//console.log(this.eBlob)
                // convert base64 to raw binary data held in a string (this is hottest js ever!)
                var byteString = atob(editedImage.split(',')[1]);
                // separate out the mime component
                var mimeString = editedImage.split(',')[0].split(':')[1].split(';')[0];
                // write the bytes of the string to an ArrayBuffer
                var ab = new ArrayBuffer(byteString.length);
                var dw = new DataView(ab);
                for(var i = 0; i < byteString.length; i++) {
                    dw.setUint8(i, byteString.charCodeAt(i));
                }
                // write the ArrayBuffer to a blob so we can upload it to firebase later
                let eBlob = new Blob([ab], {type: mimeString});

                this.eBlob = eBlob
//console.log(this.eBlob)
                var eBlobURL = URL.createObjectURL(eBlob)
                this.eBlobURL = eBlobURL
//console.log(this.eBlobURL)
                $("#colors").addClass("hide")
                $("#tools").addClass("hide")
                $("#save").addClass("hide")
                canvas.isDrawingMode = false
                canvas.selection = false;
                canvas.forEachObject(function(o) {
                    o.selectable = false;
                })
                $("#form").removeClass("hide")
                $("#back").addClass("hide")
                $("#submit").addClass("hide")
                $("#edit").addClass("hide")
            })

        },
        submit(){
            $("#form").removeClass("hide")
            $("#back").addClass("hide")
            $("#submit").addClass("hide")
            $("#edit").addClass("hide")
        },
        fireImprovement(){
            //start loader
            this.loading = true;
            //console.log(this.loading)
            //let's work
            let blob = this.blob
            let eBlob = this.eBlob
            //console.log(blob)
            //console.log(eBlob)
            //create improvement reference
            let impRef = `inst-${new Date().getTime()}`
            this.impRef = impRef
            //console.log(this.impRef)
            //store medias
            let storageRef = firebase.storage().ref().child('images');
            // store the original blob
            storageRef.child(`media-${new Date().getTime()}`).put(this.blob)
            .then(res => {
                let originalPic = {
                    'name': res.metadata.name,
                    'type': res.metadata.contentType,
                    'path': res.metadata.fullPath,
                    'created_at': Date.now(),
                    'parent': impRef,
                }
                firebase.storage().ref().child('images').child(res.metadata.name).getDownloadURL().then(url => {
                    //console.log(url)
                    this.originalPicURL = url
                    //console.log(this.originalPicURL)
                })

                // store the edited blob if exists
                if(eBlob){
                    // console.log(eBlob)
                    storageRef.child(`media-${new Date().getTime()}`).put(this.eBlob)
                    .then(e_res => {
                        let editedPic = {
                            'name': e_res.metadata.name,
                            'type': e_res.metadata.contentType,
                            'path': e_res.metadata.fullPath,
                            'created_at': Date.now(),
                            'parent': impRef
                        }
                        firebase.storage().ref().child('images').child(e_res.metadata.name).getDownloadURL().then(eurl => {
                            this.editedPicURL = eurl
                            // console.log('this editedpic url', this.editedPicURL);
                        })
                        this.editedPic = editedPic
                    })
                }
            })

            .then(() =>{
                setTimeout(() =>{
                    var url1 = this.originalPicURL
                    var url2 = this.editedPicURL

                    // console.log('url2:',url2);
                    db.collection('improvements').add({
                        ref: this.impRef,
                        created_at: Date.now(),
                        updated_at: Date.now(),
                        due_at: null,
                        user: this.user.alias,
                        service: '',
                        state: 'déclarée',
                        visual_state: '',
                        object: this.object,
                        situation: '',
                        proposal: this.proposal,
                        frequency: this.frequency,
                        pos_cons: '',
                        neg_cons: '',
                        medias: [url1, url2]
                    })
                },4500)
            })
            .then(() =>{
                //redirect user
                this.loading = false
                this.$router.push({ name:'Declared'})
            })

        },

        },
        created(){
            // get current user from users collection
            let ref = db.collection('users')
            ref.where('user_id', '==', firebase.auth().currentUser.uid).get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    this.user = doc.data()
                    this.user.id = doc.id
                })
            })
        },
        mounted(){

        },
        destroyed(){

        }
    }
    </script>

    <style lang="css" scoped>

    .idea{
        font-size: 1.3em;
        font-weight: 600;
    }

    .preview-row{
        position: absolute;
        top: 12%;
        left: 5%;
    }

    #preview{
        width: 95%;
        /* height: 100%; */
        /* top: 45px; */
        /* left: 0; */
    }

    .camera-modal{
        width: 100%;
        height: 100%;
        top: 20%;
        left: 5%;
        /* position: absolute; */
        /* background-color: transparent; */
        z-index: 1;
    }

    .camera-stream {
        width: 100%;
        /* max-height: 100%; */
    }
    /* buttons */
    .take-picture-button {
        margin-top: 50px;
        position: relative;
        z-index: 5;
    }

    #colors{
        position: absolute;
        z-index: 98;
        bottom: 20%;
        left: 8%;
    }

    #tools{
        position: absolute;
        z-index: 98;
        bottom: 30%;
        left: 34%;
    }

    #back{
        position: absolute;
        z-index: 98;
        bottom: 5%;
    }

    #edit{
        position: absolute;
        z-index: 98;
        bottom: 5%;
        right: 43%;
    }

    #form{
        position: absolute;
        /* bottom: 0%; */
    }

    .valid{
        position: absolute;
        z-index: 98;
        bottom: 5%;
        right: 5%;
    }

    textarea{
        min-height: 80px;
    }

    .loader{
        z-index: 99;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 129, 188, 0.85);
        padding-top: 25%;
    }

    .loader-text{
        color: white;
        font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;
        text-align: center;
        font-size: 1.5em;
        text-transform: uppercase;
    }

    .trinity-rings-spinner, .trinity-rings-spinner * {
      box-sizing: border-box;
    }

    .trinity-rings-spinner {
      height: 366px;
      width: 366px;
      padding: 3px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row;
      overflow: hidden;
      box-sizing: border-box;
    }
    .trinity-rings-spinner .circle {
      position:absolute;
      display:block;
      border-radius:50%;
      border: 3px solid white;
      opacity: 1;
    }

    .trinity-rings-spinner .circle:nth-child(1) {
      height: 160px;
      width: 160px;
      animation : trinity-rings-spinner-circle1-animation 1.5s infinite linear;
      border-width: 5px;
    }
    .trinity-rings-spinner .circle:nth-child(2) {
      height: calc(160px * 0.65);
      width: calc(160px * 0.65);
      animation : trinity-rings-spinner-circle2-animation 1.5s infinite linear;
      border-width: 3px;
    }
    .trinity-rings-spinner .circle:nth-child(3) {
      height: calc(160px * 0.2);
      width: calc(160px * 0.2);
      animation:trinity-rings-spinner-circle3-animation 1.5s infinite linear;
      border-width: 2px;
    }

    @keyframes trinity-rings-spinner-circle1-animation{
      0% {
        transform: rotateZ(20deg) rotateY(0deg);
      }
      100% {
        transform: rotateZ(100deg) rotateY(360deg);
      }
    }
    @keyframes trinity-rings-spinner-circle2-animation{
      0% {
        transform: rotateZ(100deg) rotateX(0deg);
      }
      100% {
        transform: rotateZ(0deg) rotateX(360deg);
      }
    }
    @keyframes trinity-rings-spinner-circle3-animation{
      0% {
        transform: rotateZ(100deg) rotateX(-360deg);
      }
      100% {
        transform: rotateZ(-360deg) rotateX(360deg);
      }
    }

    </style>
